import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Lottie from "lottie-react";
import areYouSure from "../../../../../../assets/animations/areYouSure.json";

const HolidayModeWarningDialog = ({ visible, onConfirm, onCancel }) => {
    return (
        <Dialog
            header="Temporary schedule active"
            visible={visible}
            style={{ width: "40vw" }}
            onHide={onCancel}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>
                    This site is on a temporary schedule
                </h3>
                <p style={{ textAlign: "center", color: "#6e6e6eff" }}>
                    Temporary schedules skip permanent schedules, so any change you make now will not automatically revert back afterwards.
                </p>
                <br />
                <Button label="Cancel" icon="pi pi-times" severity="secondary" onClick={onCancel} />
                <br />
                <Button label="Continue anyway" icon="pi pi-check" severity="warning" onClick={onConfirm} />
            </div>
        </Dialog>
    );
};

export default HolidayModeWarningDialog;
